export default "__VITE_ASSET__BsW99vA5__"